module.exports = __webpack_public_path__ + "img/staff.f717877f.svg";